// src/components/Users/Users.tsx
import React, { useEffect, useState } from "react";
import { listUsers } from "../../graphql/queries";
import { fetchAuthSession } from "aws-amplify/auth";
import { generateClient } from "aws-amplify/api";
import { getUrl } from "aws-amplify/storage";
import { Link } from "react-router-dom";
import "./Users.css";

const client = generateClient();

interface User {
  id: string;
  name: string;
  username?: string | null;
  email?: string | null;
  avatarUrl?: string | null;
  avatarSignedUrl?: string;
}

const Users: React.FC = () => {
  const [users, setUsers] = useState<User[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        await fetchAuthSession();
        const res = await client.graphql({
          query: listUsers,
        });

        const rawUsers = res.data?.listUsers?.items ?? [];

        const enrichedUsers = await Promise.all(
          rawUsers.filter(Boolean).map(async (user: any) => {
            if (user.avatarUrl) {
              try {
                const { url } = await getUrl({ key: user.avatarUrl });
                return { ...user, avatarSignedUrl: url.href };
              } catch {
                return user;
              }
            }
            return user;
          })
        );

        setUsers(enrichedUsers as User[]);
      } catch (error) {
        console.error("Error fetching users:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, []);

  if (loading) return <p>Loading users...</p>;

  return (
    <div className="users-container">
      <h2 className="users-title">All Users</h2>
      <div className="users-grid">
        {users.map((user) => (
          <Link to={`/profile/${user.id}`} className="user-link" key={user.id}>
            <div className="user-card">
              <img
                src={user.avatarSignedUrl || "/default-avatar.png"}
                alt={user.name}
                className="user-avatar"
              />
              <p className="user-name">{user.name}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default Users;
